import { render, staticRenderFns } from "./GeneralUserPageLayout.vue?vue&type=template&id=4b355cfc&scoped=true&"
import script from "./GeneralUserPageLayout.vue?vue&type=script&lang=js&"
export * from "./GeneralUserPageLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b355cfc",
  null
  
)

export default component.exports